// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3mMER","loaderOuter":"PageOverlayLoader_loaderOuter__2bOz5"};